<template>
  <div>
    <div>
      <vl-map ref="map" data-projection="EPSG:4326" style="height: 400px">
        <vl-view :zoom.sync="zoom" :center.sync="center" :rotation="rotation"></vl-view>

        <vl-layer-tile>
          <vl-source-osm></vl-source-osm>
        </vl-layer-tile>
        <vl-feature
          ref="featuresLayer"
          v-for="(farm, idx) in farms"
          :key="idx"
          :properties="{ acreage: farm.acreage, name: farm.name }"
        >
          <vl-geom-polygon :coordinates="[farm.coordinates]"></vl-geom-polygon>
        </vl-feature>
        <vl-interaction-select :maps.sync="selectedFeatures">
          <template slot-scope="select">
            <vl-overlay
              v-for="map in select.features"
              :key="map.id"
              :id="map.id"
              :position="map.geometry.coordinates[0][0]"
              :auto-pan="true"
            >
              <div style="background: white; border: 1px solid black">
                <b>{{ map.properties.name }}</b
                ><br />
                <b>{{ map.properties.acreage }}</b
                >&nbsp;Acres<br />
              </div>
            </vl-overlay>
          </template>
        </vl-interaction-select>
      </vl-map>
    </div>
  </div>
</template>
<script>
import { Shape } from "../../";
export default {
  props: {
    /**
     * @property {{centroid:number[],acreage:number}} farms
     */
    farms: Array,
  },
  data() {
    return {
      zoom: 18,
      center: [32.5825, 0.3476],
      rotation: 0,
      selectedFeatures: [],
    };
  },
  mounted() {
    this.getCenterPosition();
  },
  methods: {
    getCenterPosition() {
      const points = this.farms.map((el) => el.centroid);
      const shape = new Shape(points);
      this.center = shape.centroid;
    },
  },
};
</script>
